import {useEffect, useState} from 'react';
import {getDocumentContent} from "../../utils/api/document";
import {useSession} from "../../firebase/UserProvider";

export default function useDocumentContent(documentId) {
    const {user} = useSession()
    const [isLoading, setIsLoading] = useState(false);
    const [docData, setDocData] = useState(null);

    useEffect(() => {
        if (!documentId) {
            setIsLoading(false);
            setDocData(null);
            return;
        }

        setIsLoading(true);
        setDocData(null);

        const controller = new AbortController();
        getDocumentContent(documentId, controller.signal, user)
            .then((data) => setDocData(data))
            .catch((error) => {
                if (error?.name !== 'AbortError') {
                    console.error('Error fetching document:', error);
                }
            })
            .finally(() => setIsLoading(false));

        return () => controller.abort();
    }, [documentId, user]);

    return {isLoading, docData};
}
